import { MenuPanelItemId } from "../../panelItems";
import { MenuItemActivatedType } from "../../types";

/**
 * Vrací `true`, pokud se má u položky menu zobrazit rozbalivací šipka.
 *
 * Rozbalovací šipka se má zobrazit u všech položek, které mají submenu. Tj. u:
 * - kombinovaného tlačítka
 * - formulářové složky
 * - skupiny notifikací
 * - položky pro rychlý přístup
 * - položky pro uživatelské menu
 *
 * @param isCombinedItem `True`, pokud daná položka menu představuje kombinované tlačítko.
 * @param activationType Typ položky menu.
 * @param menuPanelItemId ID položky menu.
 */
export const isExpandArrowVisible = (isCombinedItem: boolean, activationType: MenuItemActivatedType | undefined, menuPanelItemId: string): boolean => (
    isCombinedItem ||
    activationType === MenuItemActivatedType.panelItemFormFolder ||
    activationType === MenuItemActivatedType.notificationGroup ||
    menuPanelItemId === MenuPanelItemId.quickAccess ||
    menuPanelItemId === MenuPanelItemId.user
);
